// extracted by mini-css-extract-plugin
export default {"slide":"Slide_slide__jE-Rd","fade_in_animation":"Slide_fade_in_animation__Y3Byh"};